import { useAuthFetch } from "@p0security/frontend-core";
import type { InstallProps } from "@p0security/integrations-installer";
import { Install } from "@p0security/integrations-installer";
import type { SnowflakeComponents } from "@p0security/integrations-snowflake-shared/components";
import { SnowflakeRegistration } from "@p0security/integrations-snowflake-shared/registry";

import { snowflakeInstaller } from "./install/install.tsx";
import { useOktaGroups } from "./useOktaGroups.ts";

// Snowflake is a "bespoke install" -- it needs Okta SCIM groups loaded
// before it can render, unlike the generic per-component installer
// framework most resource integrations use. `siblings` stay in `frontend`
// and are taken as a prop here rather than imported directly, to avoid a
// dependency back onto `frontend`.
export const Snowflake = (
  props: Pick<
    InstallProps<typeof SnowflakeComponents>,
    "cardOverride" | "onInstall" | "siblings"
  >
) => {
  const authFetch = useAuthFetch();
  // Only support Okta SCIM for now
  // using oktaAuthFetch to separate the error state from the main authFetch
  // failure in installation and configuration are different
  const { groups } = useOktaGroups(authFetch);
  return (
    <Install<typeof SnowflakeComponents>
      installer={snowflakeInstaller(groups)}
      integration="snowflake"
      registration={SnowflakeRegistration}
      {...props}
    />
  );
};
